<template>
	<div>
		<div class="py-4 px-4 sm:px-0">
			<dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
				<div class="sm:col-span-2">
					<dd class="text-sm text-gray-900 pt-4">
						<span class="font-medium text-gray-500 mr-4">Hinweis:</span>
						Sie erhalten Ihre Grundrisse i.d.R. innerhalb von 1-2 Werktagen
						per E-Mail zugesandt.
					</dd>
				</div>
			</dl>
		</div>
		<div class="px-4 py-5 sm:px-0">
			<dl
				class="grid grid-cols-1 gap-y-8 sm:grid-cols-2 rounded-lg border-gray-200 border"
			>
				<div v-if="rechnungDetails" class="sm:col-span-1 divide-y">
					<div class="p-5 font-medium">
						<dt
							class="text-lg font-semibold uppercase text-black opacity-50 mb-5"
						>
							Rechnungsadresse
						</dt>
						<dd class="text-sm text-gray-800">
							{{ rechnungDetails.Firma }}
						</dd>
						<dd class="text-sm text-gray-800">{{ rechnungDetails.Straße }}</dd>
						<dd class="text-sm text-gray-800">
							{{ rechnungDetails.Postleitzahl }} {{ rechnungDetails.Ort }}
						</dd>
						<dd class="text-sm text-gray-800">
							{{ rechnungDetails.Land.value }}
						</dd>
						<dd class="text-sm text-gray-800">{{ rechnungDetails.Telefon }}</dd>
						<dd class="text-sm text-gray-800">{{ rechnungDetails.Email }}</dd>
					</div>

					<div class="p-5">
						<dt
							class="text-lg font-semibold text-black opacity-50 py-4 flex justify-between uppercase"
						>
							Zahlungsart <CreditCardIcon class="w-6 h-6" />
						</dt>
						<dl class="py-4">
							<span
								v-if="
									formDataValues &&
									formDataValues.Zahlungsart.value === 'per Überweisung'
								"
								class="block text-center text-gray-400 font-normal text-sm py-8"
							>
								Sie zahlen per Überweisung. Die Rechnung erhalten Sie am
								nächsten Werktag
							</span>
							<div
								v-if="
									formDataValues &&
									formDataValues.Zahlungsart.value ===
										'SEPA-Lastschriftverfahren'
								"
							>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">IBAN</dt>
									<dd class="text-gray-800 font-medium">
										{{ formDataValues.IBAN }}
									</dd>
								</div>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">Bank</dt>
									<dd class="text-gray-800 font-medium">
										{{ formDataValues.Bank }}
									</dd>
								</div>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">Kontoinhaber</dt>
									<dd class="text-gray-800 font-medium">
										{{ formDataValues.Kontoinhaber }}
									</dd>
								</div>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">BIC</dt>
									<dd class="text-gray-800 font-medium">
										{{ formDataValues.BIC }}
									</dd>
								</div>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">Gläubiger ID</dt>
									<dd class="text-gray-800 font-medium">DE48ZZZ00001435190</dd>
								</div>
								<div class="mt-1 flex justify-between text-sm">
									<dt class="text-gray-600 font-semibold">Mandatsreferenz</dt>
									<dd class="text-gray-800 font-medium">1</dd>
								</div>
							</div>
						</dl>
					</div>
				</div>
				<div
					class="sm:col-span-1 bg-brand p-5 rounded-b-lg sm:rounded-r-lg sm:rounded-bl-none"
				>
					<div>
						<dt
							class="text-lg font-semibold text-blue-300 uppercase flex justify-between"
						>
							Kosten
						</dt>
						<dd class="text-4xl font-semibold text-white" >
							{{ formatter.format(cost) }}
						</dd>
						<ul class="mt-6 bg-gray-900 rounded-md divide-y divide-gray-700">
							<li
								class="pl-3 pr-4 py-5 flex items-center justify-between text-sm"
							>
								<div class="w-0 flex-1 flex items-center">
									<span class="ml-2 flex-1 w-0 truncate text-white">
										Betrag (netto):
									</span>
								</div>
								<div class="ml-4 flex-shrink-0">
									<span class="font-medium text-white">{{ formatter.format(costWithoutVAT) }}</span>
								</div>
							</li>
							<li
								class="pl-3 pr-4 py-5 flex items-center justify-between text-sm"
							>
								<div class="w-0 flex-1 flex items-center">
									<span class="ml-2 flex-1 w-0 truncate text-white opacity-60">
										zzgl. 19% Mehrwertsteuer:
									</span>
								</div>
								<div class="ml-4 flex-shrink-0">
									<span
										class="font-medium text-white opacity-60"
									>
										{{ formatter.format(VATCost) }}
									</span>
								</div>
							</li>
							<li
								class="pl-3 pr-4 py-5 flex items-center justify-between text-sm"
							>
								<div class="w-0 flex-1 flex items-center">
									<span class="ml-2 flex-1 w-0 truncate text-white font-medium">
										Gesamtbetrag (brutto):
									</span>
								</div>
								<div class="ml-4 flex-shrink-0">
									<span
										class="text-white font-medium"
									>
										{{ formatter.format(cost) }}
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</dl>
		</div>
	</div>
</template>

<script>
import { CreditCardIcon } from '@heroicons/vue/solid'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

var formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

export default {
	components: {
		CreditCardIcon,
	},
	emits: ['changed'],
	setup() {
		const store = useStore()

		const formDataValues = computed(() => {
			return { ...store.state.steps.formData }
		})

		const rechnungDetails = computed(() => {
			return { ...store.state.steps.formData.Rechnung }
		})

		const formData = computed(() => {
			return {
				formValues: { ...formDataValues.value },
				isValid: true,
				isDirty: true,
			}
		})

		let VATCost = ref(0)
		let costWithoutVAT = ref(0)
		let cost = ref(0)

		onMounted(() => {
			cost.value = formDataValues.value.overallPrice

			// Calculate 19% VAT of the cost
			VATCost.value = cost.value * 0.19

			// Calculate cost total with VAT
			costWithoutVAT.value = cost.value - VATCost.value
		})

		return {
			formData,
			formDataValues,
			rechnungDetails,
			cost,
			formatter,
			costWithoutVAT,
			VATCost,
		}
	},
}
</script>

<style lang="scss" scoped></style>
